<template>
  <div>

    <div class="header">
      <div class="left">
        <div class="logo">
          <img src="../../assets/img/logossg.png" />
        </div>
        <div class="line"></div>
        <div class="back" @click="back">返回项目列表</div>
      </div>

      <div class="company">{{this.$route.query.projectName}}</div>
    </div>
    
      <el-main>
    
    <div class="sign adaptation">
      <div class="box">
        <p class="return" @click="$router.go(-1)">返回</p>
        <span class="line">|</span>
        <p class="contract back" @click="back">项目列表</p>
        <span class="lines">></span>
        <p class="contract">关联设置</p>
      </div>
      <div class="tab_nav">
        <div class="tab_search">
          <div class="tabs">
            <span class="checked">账号权限</span>
          </div>
        </div>
        <div class="btns">
          <router-link
            :to="{path:'/ssgNewAttend/attendAddcoll',query: {id: this.$route.query.id,projectName: this.$route.query.projectName,userId:this.$route.query.userId}}"
            tag="button"
            class="btn subbtn"
          >添加协作者</router-link>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="list"
          style="width: 100%"
          :header-cell-style="{background:'#f8fafb',color: '#303140'}"
        >
          <el-table-column label="手机号" prop="mobile" min-width="120px"></el-table-column>
          <el-table-column label="子管理员" prop="name" min-width="120px"></el-table-column>
          <el-table-column label="部门" prop="orgName" min-width="180px"></el-table-column>
          <el-table-column label="邮箱" prop="email" min-width="150px"></el-table-column>

          <el-table-column label="最近登录时间" prop="lastLoginTime" min-width="150px"></el-table-column>
          <el-table-column label="开启状态" prop="status" min-width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="span_bgc">已停用</span>
              <span v-if="scope.row.status == 1" class="span_bgc4">已开启</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px" align="center">
            <template slot-scope="scope">
              <el-dropdown v-if="scope.row.admin_type!==0" placement="bottom" size="small">
                <span class="el-dropdown-link menu">
                  <span></span>
                  <i>操作</i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="scope.row.status==1"
                    @click.native="seal(scope.row.userId,0)"
                  >停用</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status==0"
                    @click.native="seal(scope.row.userId,1)"
                  >启用</el-dropdown-item>
                  <el-dropdown-item @click.native="onmodify(scope.row.userId)">编辑</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
      </el-main>

  </div>
</template>
<script>
export default {
  created() {
    this.projectName = this.$route.query.projectName
    this.loadData();
  },
  mounted() {},
  data() {
    return {
      projectName:"",
      radio: 1,
      list: [],
      tasknumber: 0,
      taskList: [],
      badgeHidden: true,
      maskshow: false,
      masktype: "",
      pushEmployTotal: 0,
      noconnect: 0,
      type: 2,
      noticeStatus: 1,
      pageNo: 1,
      pageSize: 10,
      id: "",
      total: 0,
      form: {
        name: "",
        status: "",
      },
    };
  },

  created() {
    this.loadData();
  },
  methods: {
    back(){
      this.$router.push({
        path: "/ssgNewAttend",
       
      });
    },
    seal(id, status) {
      this.$axios
        .put(
          "/eem/assist/updateStatus?status=" +
            status +
            "&userId=" +
            id +
            "&projectId=" +
            this.$route.query.id
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success(res.data.message);
            this.loadData();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    onmodify(userId) {
      this.$router.push({
        path: "/ssgNewAttend/attendAddcoll",
        query: {
          id: this.$route.query.id,
          userId: userId,
          edit: true,
          projectName:this.$route.query.projectName
        },
      });
    },
    loadData() {
      const params = {
        projectId: this.$route.query.id
      };
      return this.$axios
        .get("/eem/assist/list", {
          params,
        })
        .then((res) => {
          this.list = res.data.data;
          //   if( this.pageNo!==1 && this.list.length==0){
          //     this.pageNo = this.pageNo-1
          //     this.loadData()
          //   }
          // this.noticeStatus = res.data.data.noticeStatus -1;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
  },
};
</script>

<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">
.el-main{
  height: calc(100vh - 60px);

}
.box {
  display: flex;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 64, 1);
    margin-right: 30px;
  }
  .line {
    width: 1px;
    height: 21px;
    background-color: #d9dbe2;
    margin: 0 37px;
  }
  .back {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    cursor: pointer;
  }
   .logo {
    margin-left: 30px;
    
  }
}
.top {
  padding: 30px 0 0 0;
  .notice {
    color: #303140;
    font-weight: bold;
    font-size: 20px;
  }
  .notices {
    color: #303140;
    font-weight: bold;
    span {
      color: #6669e3;
      margin-left: 10px;
    }
  }
}
.sign {
  max-width: 1920px;
    // min-height: 100%;
    padding: 0 30px;
    margin: 0 auto;
    box-sizing: border-box;
    min-width: 1260px;

  /*background-color: #fff;
          border: 1px solid #d9dbe2;
          border-radius: 6px 6px 0 0;*/
  .operating {
    width: 100%;
    min-height: 62px;
    line-height: 62px;
    box-sizing: border-box;

    .search {
      margin-right: 14px;
    }
  }

  .table {
    width: 100%;

    .tab {
      width: 100%;
      height: 98px;
      display: flex;
      align-items: center;
      border: 1px solid #d9dbe2;
      border-radius: 12px;
      margin-bottom: 15px;
      padding: 14px 0;
      box-sizing: border-box;

      .name {
        width: 30%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 25px;
        font-size: 16px;
        color: #6669e3;
        border-right: 1px solid #f2f5f8;
      }
      .status {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: inherit;
        font-size: 12px;
        color: #9393a2;
      }

      .three {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 12px;

        p:first-child {
          color: #9393a2;
        }

        p:last-child {
          color: #545566;
        }
      }

      .axis {
        width: 40%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .bgnull {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .bg {
        width: 214px;
        height: 110px;
        background-image: url(../../assets/img/10wvB0eE.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 214px 110px;
        margin-top: 100px;
      }
    }
  }
}

.pbg {
  width: 75px;
  display: flex;
  justify-content: center;

  i {
    font-size: 54px;
    color: #3bc798;
  }
}

.part {
  font-size: 18px;
  margin-left: 10px;

  p {
    margin: 5px 0;

    .red {
      color: #ff6752;
    }

    .green {
      color: #3bc798;
    }
  }
}
.submess {
  .form {
    display: flex;
    /*justify-content: space-around;*/
    .img {
      background-image: url("../../assets/img/warning.png");
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
    }
    .linhin {
      margin-left: 30px;
      height: 100px;
      line-height: 30px;
      .p1 {
        font-size: 14px;
        color: #303140;
        font-weight: bold;
      }
      .p2 {
        color: #303140;
      }
      .rad {
        color: #303140;
        .no {
          display: block;
          margin-left: 90px;
        }
      }
    }
  }
}
.filter {
  width: 100%;
  height: 57px;
  background: rgba(242, 245, 248, 1);
  border-radius: 4px;
  margin-bottom: 30px;
  .content {
    display: flex;
  }
  size {
    font-size: 12px;
    font-weight: 400;
    color: rgba(84, 85, 102, 1);
    margin-left: 10px;
    margin-right: 10px;
  }
}
.opera {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border-left: 1px solid #f2f5f8;
  color: #6669e3;
  span {
    margin: 0 5px;
    color: #6669e3;

    cursor: pointer;
  }
}
.span_bgc {
  padding: 3px 5px;
  background: rgba(254, 240, 240, 1);
  border-radius: 4px;
  border: 1px solid rgba(252, 210, 210, 1);
  font-size: 12px;
  font-weight: 400;
  width: 50px;
  color: rgba(245, 116, 116, 1);
}

.span_bgc4 {
  padding: 3px 5px;
  background: rgba(234, 255, 248, 1);
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 199, 152, 1);
  border-radius: 4px;
  width: 50px;
  border: 1px solid rgba(183, 225, 211, 1);
}
</style>
